import { render, staticRenderFns } from "./DashboardCommercialBicimax.vue?vue&type=template&id=5676ad9e"
import script from "./DashboardCommercialBicimax.vue?vue&type=script&lang=js"
export * from "./DashboardCommercialBicimax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports